module.exports = __webpack_public_path__ + "static/media/image-card-5.ca05bb15.png";